import angular from 'angular'
import { AssignedEventsCalendarModule } from './assigned-events-calendar/assigned-events-calendar.module';
import { RoadShowsScheduleModule } from './road-shows/road-shows-schedule.module';
import { EventsSchedulingDashboardModule } from './dashboard/events-scheduling-dashboard.module';
import { EventsSchedulingSharedModule } from './shared/events-scheduling-shared.module';
import { EventsRepAssignmentModule } from './events-rep-assignment/events-rep-assignment.module';
import { EventsSchedulingReportModule } from './reports/event-scheduling-report.module';
import { EventsSchedulingRoutingModule } from './events-scheduling-routing.module';

/**
 * A module that relates to allowing ICDs to view events assigned
 * within their hierarchy, and to allow them to manage time slots.
 */
export const EventsSchedulingModule = angular
    .module("apex.mainApp.eventsScheduling", [
        // Use components for displaying event host details.
        EventsSchedulingSharedModule,
        EventsSchedulingRoutingModule,

        AssignedEventsCalendarModule,
        EventsSchedulingDashboardModule,
        RoadShowsScheduleModule,
        EventsRepAssignmentModule,
        EventsSchedulingReportModule
    ])
    .name;
